import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'mo-logged-out-sidebar',
    templateUrl: './logged-out-sidebar.component.html',
    styleUrls: ['./logged-out-sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoggedOutSidebarComponent {}
